import { render, staticRenderFns } from "./PlatformInfo.vue?vue&type=template&id=a2cd228c&scoped=true"
import script from "./PlatformInfo.vue?vue&type=script&lang=js"
export * from "./PlatformInfo.vue?vue&type=script&lang=js"
import style0 from "./PlatformInfo.vue?vue&type=style&index=0&id=a2cd228c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2cd228c",
  null
  
)

export default component.exports